/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Funnel_Sq_Join_HeadingInputs */

const en_funnel_sq_join_heading = /** @type {(inputs: Funnel_Sq_Join_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Join 500,000+ students & researchers.`)
};

const es_funnel_sq_join_heading = /** @type {(inputs: Funnel_Sq_Join_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Únete a más de 500.000 estudiantes e investigadores.`)
};

/**
* | output |
* | --- |
* | "Join 500,000+ students & researchers." |
*
* @param {Funnel_Sq_Join_HeadingInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const funnel_sq_join_heading = /** @type {((inputs?: Funnel_Sq_Join_HeadingInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Funnel_Sq_Join_HeadingInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_funnel_sq_join_heading(inputs)
	return en_funnel_sq_join_heading(inputs)
});